import DOMPurify from 'dompurify';

/**
 * ## cortex:react-ui-std:sanitizedInjectHTML
 * Sanitization is the inspection of an untrusted value, turning it into a value that's safe to insert into the DOM.
 */
export function sanitizedInjectHTML(htmlString: string): { __html: string } {
	return { __html: DOMPurify.sanitize(htmlString) };
}
